module.exports = __webpack_public_path__ + "static/media/experiment-5.16f89eba.PNG";